import React, { useEffect, useState, useRef } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { Container, Button, Card, Spinner, Modal } from "react-bootstrap";
import { ArrowLeft } from "react-feather";

import AddressForm from "./_form";
import apiService from "../../services/apiService";
import { useNotification } from "../../components/notification";

const AddAddress = () => {
  const { userId, addressId } = useParams();
  const navigate = useNavigate();
  const formRef = useRef();

  const { showNotification } = useNotification();
  const [isPageLoading, setIsPageLoading] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [existingAddress, setExistingAddress] = useState(null);

  const handleSave = () => {
    if (formRef.current) {
      formRef.current.submitForm(); // Trigger form submission
    }
  };

  // Handle add/edit address
  const saveAddress = async (data) => {
    try {
      setIsSubmitting(true);
      if (userId && addressId && existingAddress) {
        await apiService.put(`/addresses/${addressId}`, {
          ...data,
          userId: userId,
        });
      } else {
        await apiService.post("/addresses", {
          ...data,
          userId: userId,
        });
      }
      showNotification("success", "Address saved successfully!", 5000);
      navigate(-1); // Go back after save
    } catch (error) {
      showNotification("danger", error || "Failed to save address.", 5000);
    } finally {
      setIsSubmitting(false);
    }
  };

  useEffect(() => {
    if (addressId) {
      const fetchAddress = async () => {
        setIsPageLoading(true);
        try {
          const response = await apiService.get(`/addresses/${addressId}`);
          setExistingAddress(response);
        } catch (error) {
          showNotification("danger", error || "Failed to load address.", 5000);
        } finally {
          setIsPageLoading(false);
        }
      };
      fetchAddress();
    }
  }, [addressId, showNotification]);

  return (
    <Container fluid className="p-0">
      <Card className="p-4 border-0">
        <Card.Body>
          <div className="d-flex align-items-center justify-content-between mb-2">
            <h1 className="mb-0 fs-5">
              {addressId ? "Edit Address" : "Add New Address"}
            </h1>
            <Button
              variant="light"
              onClick={() => navigate(-1)}
              className="me-3"
            >
              <ArrowLeft size={18} /> Back
            </Button>
          </div>
          <p className="mb-0 text-light-emphasis fw-light">
            {userId
              ? "Update the address details below."
              : "Please enter the address details below."}
          </p>
          <hr className="mt-3 mb-4" />

          <AddressForm
            onSubmit={saveAddress}
            existingAddress={existingAddress}
            ref={formRef}
          />
          <div className="mt-4">
            <Button
              variant="primary"
              disabled={isSubmitting}
              className="btn-main"
              onClick={handleSave}
            >
              {isSubmitting ? (
                <Spinner animation="border" role="status">
                  <span className="visually-hidden">Loading...</span>
                </Spinner>
              ) : addressId ? (
                "Update Address"
              ) : (
                "Save Address"
              )}
            </Button>
          </div>
        </Card.Body>
      </Card>
      <Modal
        show={isPageLoading}
        aria-labelledby="Loading"
        className="modal-loading"
        contentClassName="bg-transparent border-0"
        centered
      >
        <Modal.Body className="text-center">
          <Spinner animation="border" role="status" variant="primary">
            <span className="visually-hidden">Loading...</span>
          </Spinner>
        </Modal.Body>
      </Modal>
    </Container>
  );
};

export default AddAddress;
